import { useEffect } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import ListKtgWorkersPage from '@/components/pages/guest/_ktg-worker-list/containers/ktg-worker-list-page'
import { useFilters } from '@/components/pages/guest/_ktg-worker-list/state/filters-atom'
import { searchParamsSchema } from '@/components/pages/guest/_ktg-worker-list/types'

export const Route = createFileRoute('/_guest/guest/ktg-worker-list')({
  component: RouteComponent,
  validateSearch: searchParamsSchema
})

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const filters = useFilters()

  useEffect(() => {
    if (search.province_code) {
      filters.onProvinceChange(search.province_code, false)
    }
    if (search.city_code) {
      filters.onCityChange(search.city_code, false)
    }
    if (search.type) {
      filters.onPenyuluhTypeChange(search.type, false)
    }
    if (search.status) {
      filters.onPenyuluhStatusChange(search.status, false)
    }
    if (search.position) {
      filters.onPenyuluhPositionChange(search.position, false)
    }
    if (search.gender) {
      filters.onGenderChange(search.gender, false)
    }
    if (search.skill) {
      filters.onSkillChange(search.skill, false)
    }
    if (search.education) {
      filters.onEducationChange(search.education, false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    search.province_code,
    search.city_code,
    search.type,
    search.status,
    search.position,
    search.gender,
    search.skill,
    search.education
  ])

  return (
    <ListKtgWorkersPage
      activeTab={search.tab}
      onTabChange={tab => {
        navigate({ search: { ...search, tab } })
      }}
    />
  )
}
